const ForgotPasswordPage = {
  seo: {
    title: 'Forgot Password',
  },
};

export default ForgotPasswordPage;
